module.exports = __webpack_public_path__ + "static/actionbar-spellnumbers-do-98568588852e9b3a9e951be4999cacc4.png";